<template>
	<div class="app">
		<div class="top">
			<div class="select">
				<span>您当前的地区:</span>
				<select v-model="selected">
					<option value="anhui">安徽</option>
					<option value="fujian">福建</option>
					<option value="guangxi">广西</option>
					<option value="hunan">湖南</option>
					<option value="shanxi">陕西</option>
					<option value="guangdong">广东</option>
					<option value="sichuan">四川</option>
					<option value="yunnan">云南</option>
				</select>
				<span>[切换省份]</span>
			</div>
			<a :href=this.url >
				<img :src=this.topimg />
			</a>
		</div>
		<div class="banner">
			<img :src=this.bannerimg />
		</div>
		<div class="download">
			<h2>下载游戏</h2>
			<div class="dwimg">
				<div class="left">
					<img :src=this.dwimg  />
				</div>
				<div class="right">
					<a v-bind:href=this.iosUrl class="top">
						<div class="dw_right_top_img">
							<img src="../../images/xl_download_19.png">
						</div>
						<div class="dw_right_top_dow"><span class="appstore">App&nbsp; Store</span><span>下载</span></div>
					</a>

					<a :href=this.url class="bottom">
							<img src="../../images/xl_download_21.png" class="dw_right_bottom_img"/>
						<div class="dw_right_bottom_dow"><p>安卓下载</p></div>
					</a>
				</div>
			</div>
		</div>
		<div class="attention">
			<h2>关注客服公众号</h2>
			<div class="img">
				<img :src=this.dwimg />
			</div>
			<p>
				识别二维码关注我们的微信公众号，获得引导信息。
			</p>
		</div>
		<div class="feature">
			<h2>游戏特色</h2>
		   	 <div class="swiper-container">
			    <div class="swiper-wrapper">
			        <div class="swiper-slide">
			        	<img :src=this.img1 />
			        </div>
			        <div class="swiper-slide">
			        	<img :src=this.img2 />
			        </div>
			        <div class="swiper-slide">
			        	<img :src=this.img3 />
			        </div>
			    </div>
			    <!-- 如果需要分页器 -->
			    <div class="swiper-pagination"></div>

			</div>
			<!-- 如果需要导航按钮 -->
			<div class="swiper-button-prev" ></div>
			<div class="swiper-button-next"></div>
			<a :href=this.url class="button">
				<img src="../../images/active/down_img_07.png" /><span>立即下载</span>
			</a>
		</div>
		<div class="activefooter">
			<div class="activelog">
				<img class="logo" src="../../images/footer_nav_49.png" alt="闲徕互娱">
			</div>
			<p>Copyright © 2016 - 2017 京ICP备16022346号-4</p>
			<p>京网文[2016]1755-215号</p>
			<p>增值电信业务经营许可证 京B2-20170093 京公网备案</p>
			<p>公司名称：北京闲徕互娱网络科技有限公司</p>
			<p>公司地址：北京市朝阳区天朗园C座3层03商业3-008</p>
			<p>公司电话：010-84935767</p>
		</div>

	</div>
</template>

<script>
	import '../../untils/swiper.min.css'

	export default {
		data () {
			var province=this.$route.params.province
			console.log(province)
			return {
				selected:province,
				topimg:require(`../../images/active/top-${province}.png`),
				bannerimg:require(`../../images/active/banner-${province}.jpg`),
				dwimg:require(`../../images/active/xl-${province}.jpg`),
				iosUrl:"",
				url:`http://app1.xlsxmj.com/?downloadfrom=${province}`,
				img1:require(`../../images/active/${province}_banner01.jpg`),
				img2:require(`../../images/active/${province}_banner02.jpg`),
				img3:require(`../../images/active/${province}_banner03.jpg`),
				data:{
						"anhui":{
								"iosUrl":"https://itunes.apple.com/cn/app/id1191689756?mt=8"

						},
						"fujian":{
								"iosUrl":"https://itunes.apple.com/cn/app/ba-min-fu-jian-ma-jiang/id1157504149?mt=8"

						},
						"guangxi":{
								"iosUrl":"https://itunes.apple.com/cn/app/%E5%B9%BF%E8%A5%BF%E5%B1%B1%E6%B0%B4%E9%BA%BB%E5%B0%86-%E9%97%B2%E6%9D%A5%E6%B2%B3%E6%B1%A0%E7%99%BE%E8%89%B2%E7%9A%84%E6%A3%8B%E7%89%8C%E7%8E%A9%E6%B3%95/id1192209091?l=zh&ls=1&mt=8"

						},
						"hunan":{
								"iosUrl":"https://itunes.apple.com/cn/app/闲来麻将-正宗湖南转转麻将红中癞子玩法/id1230064724?l=zh&ls=1&mt=8"

						},
						"shanxi":{
								"iosUrl":"https://itunes.apple.com/cn/app/%E9%97%B2%E6%9D%A5%E9%99%95%E8%A5%BF%E9%BA%BB%E5%B0%86/id1217827068?l=zh&ls=1&mt=8"

						},
						"guangdong":{
								"iosUrl":"https://itunes.apple.com/cn/app/%E5%B9%BF%E4%B8%9C%E9%BA%BB%E5%B0%86%E7%B2%BE%E5%8D%8E%E7%89%88/id1208771866?l=zh&ls=1&mt=8"

						},
						"sichuan":{
								"iosUrl":"https://itunes.apple.com/cn/app/熊猫麻将官方版-正宗四川血战到底/id1220692308?l=zh&ls=1&mt=8"

						},
						"yunnan":{
								"iosUrl":"https://itunes.apple.com/cn/app/shan-shui-yun-nan-ma-jiang/id1156035437?mt=8"

						}

					}

			}
		},
		methods : {
			lunbo () {
				var mySwiper = new Swiper ('.swiper-container', {
					initialSlide :0,
				    loop: true,
				    autoplay: 3000,
				    autoplayDisableOnInteraction : false,
				    roundLengths : true,

				    // 如果需要前进后退按钮
				    nextButton: '.swiper-button-next',
				    prevButton: '.swiper-button-prev'

			 	 })
			}
		},
		components :{

		},
		mounted () {
			var province=this.$route.params.province
			this.iosUrl=this.data[province].iosUrl;
			// this.lunbo()
			/*
			 * 友盟统计
			 */
//			var cnzz_protocol = (("https:" == document.location.protocol) ? " https://" : " http://");
//			document.write(unescape("%3Cspan id='cnzz_stat_icon_1261606230'%3E%3C/span%3E%3Cscript src='" + cnzz_protocol + "s4.cnzz.com/z_stat.php%3Fid%3D1261606230%26show%3Dpic' type='text/javascript'%3E%3C/script%3E"));




		},
		updated(){
				var updateProvince=this.selected;
				// console.log(updateProvince)
				this.topimg=require(`../../images/active/top-${updateProvince}.png`);
				this.bannerimg=require(`../../images/active/banner-${updateProvince}.jpg`);
				this.dwimg=require(`../../images/active/xl-${updateProvince}.jpg`);
				this.url=`http://app1.xlsxmj.com/?downloadfrom=${updateProvince}`;
				this.iosUrl=this.data[updateProvince].iosUrl;
				this.img1=require(`../../images/active/${updateProvince}_banner01.jpg`);
				this.img2=require(`../../images/active/${updateProvince}_banner02.jpg`);
				this.img3=require(`../../images/active/${updateProvince}_banner03.jpg`);

				this.lunbo()
		}
	}
</script>

<style>

</style>



// WEBPACK FOOTER //
// Active.vue?b0b0ebc8